import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { CertificacionI } from "interfaces/Certificacion";
import { Dropdown } from "react-bootstrap";
import { deleteCertificacion } from "services/certificacion";

interface Props {
  elemento: CertificacionI;
  onClickEdit: (elemento: CertificacionI) => void;
  refreshTable: () => void;
}

export const CertificacionesRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteCertificacion(id);
      showSuccessToast("¡La certificación fue eliminada con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando la certificación: ", error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar certificación"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la certificación {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
